// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"ReflectionReferences_headerContainer__gvcjY"};